import { isNil } from 'lodash'

const MS_PER_MINUTE = 60 * 1000

export const getAverageFlowRateGpm = (gallons: number | null, onDurationMs: number | null): number | null => {
  if (isNil(gallons) || isNil(onDurationMs) || onDurationMs <= 0) return null

  return gallons / (onDurationMs / MS_PER_MINUTE)
}
